let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUe6N")).then(() => parcelRequire('hagIH'));